import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { signOut } from "next-auth/react";
import { LegalDocumentLinksWithModal } from "./LegalDocumentLinksWithModal";

type Props = {
  open: boolean;
  isFirstAcceptancePrompt: boolean;
  accepting: boolean;
  onAccept: () => void;
};

export function LegalAcceptanceBlockingDialog({
  open,
  isFirstAcceptancePrompt,
  accepting,
  onAccept,
}: Props) {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" disableEscapeKeyDown>
      <DialogTitle>
        {isFirstAcceptancePrompt ? "Welcome" : "Agreement required"}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {isFirstAcceptancePrompt
            ? "To use ScripTea, please read and accept our Terms of Service and Privacy Policy. You can open each document below."
            : "Updated legal documents are now in effect. Accept them to continue using the app, or sign out."}
        </Typography>
        <LegalDocumentLinksWithModal />
      </DialogContent>
      <DialogActions>
        <Button
          color="inherit"
          onClick={() => void signOut({ callbackUrl: "/" })}
        >
          Sign out
        </Button>
        <Button onClick={onAccept} variant="contained" disabled={accepting}>
          I agree
        </Button>
      </DialogActions>
    </Dialog>
  );
}
